import { ArrowLeft, LogOut, ShieldAlert } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'
import Button from '../components/ui/Button'
import ProfileInfoForm from '../components/settings/ProfileInfoForm'
import PasswordChangeForm from '../components/settings/PasswordChangeForm'
import { useAuth } from '../contexts/AuthContext'
import { useLang } from '../contexts/LangContext'

export default function SettingsPage() {
  const { currentUser, signOut } = useAuth()
  const { t } = useLang()
  const navigate = useNavigate()

  function handleSignOut() {
    signOut()
    navigate('/', { replace: true })
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-8 md:px-6 md:py-10">
      <Link to={currentUser?.role === 'provider' ? '/provider/dashboard' : '/dashboard'} className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-800">
        <ArrowLeft className="h-4 w-4" />
        {t('Επιστροφή', 'Back')}
      </Link>

      <section className="mt-6 rounded-[2rem] border border-slate-200 bg-[linear-gradient(135deg,#ffffff_0%,#f8fafc_55%,#eff6ff_100%)] p-6 shadow-sm md:p-8">
        <p className="text-sm font-semibold uppercase tracking-[0.22em] text-primary-600">
          {t('Ρυθμίσεις', 'Settings')}
        </p>
        <h1 className="mt-3 text-4xl font-black tracking-tight text-slate-950 sm:text-5xl">
          {t('Λογαριασμός & προτιμήσεις', 'Account and preferences')}
        </h1>
        <p className="mt-4 max-w-3xl text-lg leading-8 text-slate-600">
          {t('Επεξεργάσου το προφίλ σου, άλλαξε κωδικό και διαχειρίσου βασικές ενέργειες λογαριασμού.', 'Edit your profile, change your password, and manage core account actions.')}
        </p>
      </section>

      <div className="mt-8 space-y-8">
        <ProfileInfoForm />
        <PasswordChangeForm />

        <section className="rounded-[1.75rem] border border-slate-200 bg-white p-6 shadow-sm">
          <h2 className="text-2xl font-bold text-slate-950">{t('Ενέργειες λογαριασμού', 'Account actions')}</h2>
          <p className="mt-2 text-sm leading-7 text-slate-600">
            {t('Η αποσύνδεση καθαρίζει το τρέχον session. Η διαγραφή λογαριασμού θα προστεθεί αργότερα.', 'Signing out clears the current session. Account deletion will be added later.')}
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Button type="button" variant="secondary" onClick={handleSignOut}>
              <LogOut className="h-4 w-4" />
              {t('Αποσύνδεση', 'Sign out')}
            </Button>
            <Button type="button" variant="ghost" disabled>
              <ShieldAlert className="h-4 w-4" />
              {t('Διαγραφή λογαριασμού (σύντομα)', 'Delete account (coming soon)')}
            </Button>
          </div>
        </section>
      </div>
    </div>
  )
}
